export default function PublicWorksDetails() {
    return (
      <div>
 <div className="pworks-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
    <h2>Public Works</h2>
</div>

{/*End Large Image Space*/}
{/*Start Main Content*/}
<div className="content-fluid">

    <div className="mb-960-center-container mid-side-outlines">
        {/*Full Width Element*/}
        <div className="mb-960-col-50p">
            <div className="left-right-padding-1em">
                <br/>
                <h4>General Information</h4>
                <p>The Public Works Department is responsible for the maintenance of the town's property; this includes:</p>
                <ul>
                    <li>Maintaining 32 miles of roadway, including storm drains, signage, crosswalks, and potholes.</li>
                    <li>Repairing and servicing the Water &amp; Sewer System</li>
                    <li>Repairing the town's street lights</li>
                    <li>Maintaining and trimming Borough owned trees</li>
                    <li>Maintaining the levee at Williamson Park</li>
                    <li>Park maintenance</li>
                    <li>Facility maintenance</li>
                </ul>
            </div>
        </div>
        <div className="mb-960-col-50p">
            <div className="left-right-padding-1em">
                <br/>
                <h4>Citizen Reporter</h4>
                <p>If you believe something requires Public Works attention, please use the <a href="../citizenreporter">Citizen Reporter&nbsp;<i className="fa-solid fa-link"></i></a> system to submit a ticket.</p>

            </div>
        </div>
    </div>
    <div className="mb-960-center-container mid-side-outlines padding-left-right">
        {/*Accordian Start*/}
        <div className="container accordion-container">
            <div className="accordion" id="pworksAccordion">
                {/* Item Start */}
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseStreetLights">
                            <div>
                                <i className="fa-solid fa-lightbulb fa-2xl feature-icon af-icon"></i>
                            </div>

                            <div><b>Street Light Issues</b></div>
                        </button>
                    </h2>
                    <div id="collapseStreetLights" className="accordion-collapse collapse" data-bs-parent="pworksAccordion">
                        <div className="accordion-body">
                            If there is a need to report anything involving a street light, you may do so using <a href="../citizenreporter">Citizen Reporter&nbsp;<i className="fa-solid fa-link"></i></a> (instructions below):
                            <ul>

                                <li>Visit the <a href="../citizenreporter">Citizen Reporter&nbsp;<i className="fa-solid fa-link"></i></a> page and Launch Citizen Reporter</li>

                                <li>Click on “Street &amp; Storm Water”</li>
                                <li>Click on “Street Issues”</li>
                                <li>Under Nature of Request select “Street Light”</li>
                            </ul>

                            <p>When reporting a Street Light outage, please be sure to include the address of the pole and a pole number. This will assist the Public Works Department with locating the light.</p>
                        </div>
                    </div>
                </div>
                {/* Item Finish */}
                {/* Item Start */}
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePotHole">
                            <div>
                                <i className="fa-solid fa-road fa-2xl feature-icon af-icon"></i>
                            </div>

                            <div><b>Report Pot Holes</b></div>
                        </button>
                    </h2>
                    <div id="collapsePotHole" className="accordion-collapse collapse" data-bs-parent="pworksAccordion">
                        <div className="accordion-body">
                            <h4>PennDot Pothole Reports</h4>
                            Please contact PennDOT at <a href="tel:18003497623"><i className="fa-solid fa-phone"></i>&nbsp;1-800-FIX-ROAD (1-800-349-7623)</a> or file a report at <a href="http://customercare.penndot.gov/">customercare.penndot.gov/&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a> if you are inquiring about a pothole on the following roads:
                            <ul>
                                <li>Delmorr Avenue</li>
                                <li>Pennsylvania Avenue</li>
                                <li>Trenton Avenue</li>
                                <li>Bridge Street</li>
                            </ul>
                            <h4>Borough Roads Potholes</h4>
                            For all non-PennDOT roads, please report a pothole using <a href="../citizenreporter">Citizen Reporter&nbsp;<i className="fa-solid fa-link"></i></a> (instructions below):

                            <ul>
                                <li>Visit the <a href="../citizenreporter">Citizen Reporter&nbsp;<i className="fa-solid fa-link"></i></a> page and Launch Citizen Reporter</li>
                                <li>Click on “Street &amp; Storm Water”</li>
                                <li>Click on “Street Issues”</li>
                                <li>Under Nature of Request select “Pothole”</li>
                            </ul>

                            <p>When completing the form, please be sure to complete the entire form. This will assist the Public Works Department with locating the problem. While the Public Works Department will attend to the pothole as quickly as possible, please be aware of the streets in the Borough which are owned and maintained by PennDOT.</p>
                        </div>
                    </div>
                </div>
                {/* Item Finish */}
                {/* Item Start */}
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSnowPlow">
                            <div>
                                <i className="fa-solid fa-snowflake fa-2xl feature-icon af-icon"></i>
                            </div>

                            <div><b>Snow Removal &amp; Plowing</b></div>
                        </button>
                    </h2>
                    <div id="collapseSnowPlow" className="accordion-collapse collapse" data-bs-parent="pworksAccordion">
                        <div className="accordion-body">
                            <p>
                            For the goal of safe and effective snow plowing, it is crucial that the Borough and residents work together. By providing the following information for residents, the town will be on track to accomplish that goal.</p>
                            
                            <h4>Borough Responsibilities</h4>
                            <p>In the event of snow, the Morrisville Borough Public Works Department is responsible for snow plowing on all Borough roads and Borough-owned sidewalks. Please understand that the roads that are considered “main arteries” of the Borough shall be cleared of snow first.</p>
                            <h4>Resident Responsibilities</h4>
                            <p>In the event of snow, residents are prohibited from blowing or shoveling snow into the streets. Doing so is illegal and causes a safety hazard. Violators are subject to a citation. During snow plowing operations, please keep children out of the streets. Snow forts and tunnels near the edge of the roadway are prohibited.</p>

                            <p>The Public Works Department requests that residents park in their driveways, if they have a driveway. By clearing the streets, it allows the department to be more efficient when clearing the roads.</p>

                            <p>When parking near an intersection, please make sure to leave ample room by the intersection. Parking too closely to an intersection will hinder the abilities of snow plows and emergency responders.</p>

                            <p>If you are a resident that lives near an alley, please ensure that the entryways to the alley are clear of vehicles. The same applies to residents that live across an entryway to an alley. Please refrain from parking directly next to the entrance and exit ways of an alley — doing this ensures that the department’s plows can turn into the alleys.</p>

                            <p>In the event where snow is plowed and deposited in the apron area of a resident's driveway, it is the resident's responsibility to remove the snow. Please understand that the Public Works Department has to plow snow from the street, and the process may require several rounds. Therefore, residents are advised to wait as long as possible before shoveling their aprons.</p>

                            <p>Sidewalks must be cleared of snow within 24 hours after the storm has passed. Violators may be cited in accordance with Borough Ordinance. Any residents that live near an intersection are responsible to clear the sidewalk apron of snow. Doing this enables pedestrian crossing.</p>

                            <p>If a resident has a complaint or concern, they may contact the Public Works Superintendent at 267-399-9046. This number will be monitored during the weather event, and complaints and concerns will be addressed in a timely manner.</p>

                            <p>It is important to remember that each snow storm is unique; some may entail more work than others. However, with the town's cooperation and assistance, the roads will be cleared in a safe and timely manner.</p>

                            <p><a href="https://ecode360.com/15934909">Morrisville Borough Snow and Ice Clearing Ordinance&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
                            <h4>Snow Emergency</h4>
                            <p>
                                Street parking of any form on Snow Emergency Routes will be prohibited.</p>
                            <h4>Snow Emergency Routes</h4>
                            <p>
                                East Philadelphia Avenue<br/>
                                North Delmorr Avenue<br/>
                                Pennsylvania Avenue<br/>
                                Trenton Avenue<br/>
                                Bridge Street<br/>
                            </p>
                            <p>Since these roads are considered Emergency Routes, they will receive priority in the event of snow. The Public Works Department will work in conjunction with PennDOT in order to plow these roadways. Any violators will be ticketed and/or towed.</p>

                        </div>
                    </div>
                </div>
                {/* Item Finish */}
                

            </div>
        </div>
    </div>
    {/*Accordian End*/}

</div>




<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
</div>




      </div>
    )
}
